// Import model
import { ObjectFileCondition } from '../models/ObjectFileCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ObjectFileIndexedFields } from '../models/ObjectFileIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ObjectFileIndexedFieldsSerializer } from './ObjectFileIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ObjectFileCondition - handles JSON serialization and deserialization with type validation
 */
export class ObjectFileConditionSerializer {
  /**
   * Deserializes a JSON string into a ObjectFileCondition instance
   */
  static deserialize(json: string): ObjectFileCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ObjectFileCondition instance
   */
  static fromObject(obj: any): ObjectFileCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ObjectFileCondition');
    }


    const instance: ObjectFileCondition = {
      fieldName: obj['fieldName'] as ObjectFileIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ObjectFileCondition instances
   */
  static deserializeArray(json: string): ObjectFileCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ObjectFileCondition instance to a JSON string
   */
  static serialize(instance: ObjectFileCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ObjectFileCondition instance to a plain object
   */
  static toObject(instance: ObjectFileCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ObjectFileCondition instances to a JSON string
   */
  static serializeArray(instances: ObjectFileCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
